module.exports = __webpack_public_path__ + "static/media/teacher.875642ce.pdf";